<template>
  <b-navbar type="light" variant="light" toggleable="md">
    <b-navbar-brand :to="{ name: 'home' }">Home</b-navbar-brand>
    <b-navbar-nav>

        <b-nav-item-dropdown text="Erkunden" right>
            <b-nav-item :to="{ name: 'about' }">In Kürze</b-nav-item>
            <b-nav-item :to="{ name: 'flyer' }">Über uns</b-nav-item>
            <b-nav-item :to="{ name: 'faq' }">FAQ</b-nav-item>
            <b-nav-item :to="{ name: 'calendar' }">Veranstaltungen</b-nav-item>
            <!--<b-nav-item :to="{ name: 'search' }">Dokumentensuche</b-nav-item>-->
        </b-nav-item-dropdown>

      <b-nav-item-dropdown v-if="isAuthenticated" text="Interna" right>
        <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'internfaq' }">Interne FAQ</b-dropdown-item>
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'functions' }">Chargierte</b-dropdown-item>
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'tasks' }">Ämter & Aufgaben</b-dropdown-item>
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'meetings' }">Veranstaltungsplaner</b-dropdown-item>
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'jubilee' }">125. Stiftungsfest</b-dropdown-item>
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'promotion' }">Werbemaßnahmen</b-dropdown-item>
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'excursions' }">Exkursionen</b-dropdown-item>
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'downloads' }">Downloadbereich</b-dropdown-item>
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'upload' }">Upload-Formular</b-dropdown-item>
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'dignitaries' }">Ehrenphilister</b-dropdown-item>
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'memory' }">Im Gedenken</b-dropdown-item>
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'presidents' }">Liste der Senioren</b-dropdown-item>
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'profiles' }">Steckbriefe</b-dropdown-item>
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'address' }">Adressen-Update</b-dropdown-item>
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'penalties' }">Strafenkatalog</b-dropdown-item>
         <!--
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'countdown' }">Countdown</b-dropdown-item>
         -->
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'changelog' }">Changelog</b-dropdown-item>
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'credits' }">Credits</b-dropdown-item>
         <b-dropdown-item v-if="isAuthenticated" :to="{ name: 'cinema' }">Kino</b-dropdown-item>
      </b-nav-item-dropdown>

      <!--
      <b-nav-item-dropdown  v-if="isAuthenticated" text="Bilder" right>
        <b-dropdown-item  v-if="isAuthenticated" :to="{ name: 'gallery2020' }">2020</b-dropdown-item>
        <b-dropdown-item  v-if="isAuthenticated" :to="{ name: 'gallery2019' }">2019</b-dropdown-item>
        <b-dropdown-item  v-if="isAuthenticated" :to="{ name: 'gallery2005' }">2005</b-dropdown-item>
        <b-dropdown-item  v-if="isAuthenticated" :to="{ name: 'gallery2003' }">2003</b-dropdown-item>
        <b-dropdown-item  v-if="isAuthenticated" :to="{ name: 'gallery1979' }">1979</b-dropdown-item>
        <b-dropdown-item  v-if="isAuthenticated" :to="{ name: 'cinema' }">Kino</b-dropdown-item>
      </b-nav-item-dropdown>
      -->

      <b-nav-item v-if="!isAuthenticated && !authLoading" :to="{ name: 'login' }">Login</b-nav-item>
      <b-nav-item v-if="isAuthenticated" @click="logout">Logout</b-nav-item>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>

  import { mapGetters, mapState } from 'vuex'
  import { AUTH_LOGOUT } from '@/store/actions/auth'

export default {
    name: 'HeaderNavbar',
    methods: {
          logout: function () {
            this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/'))
          }
        },
        computed: {
          ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded']),
          ...mapState({
            authLoading: state => state.auth.status === 'loading',
            name: state => `${state.user.profile.title} ${state.user.profile.name}`,
          })
        },
};
</script>
